// Nav badge for Sales > Invoices: number of orders on the To-invoice tab (GET /sales-invoices/to-invoice/count = the tab's own rows.length, memoised on the api).
// Shared by LeftMenu + ModuleBar; same cadence as dispatchCount (api write bus + every 60 s). Fail-soft: null hides it.
import { useState, useEffect } from 'react';
import { onDataMutation } from '../services/api';
import { parseCount, touchesWorklist } from './invoiceCount.logic.mjs';
import { shellRead, shellPoll } from './shellRead';

let _count = null;
const _subs = new Set();
let _timer = null;
let _unsub = null;

// perf-badge: the api caches the count (warm per process), so the poll sends no flag. Round 4e: read through shellRead (one shell request, after
// paint) and polled by the shell's ONE timer (60 s, paused while hidden, no overlap) instead of this store's own.
const apply = (r, err) => { _count = err ? null : parseCount(r); _subs.forEach(fn => fn(_count)); };
const load = () => shellRead('to_invoice').then(r => apply(r), e => apply(null, e));

export function useInvoiceCount(enabled = true) {
  const [n, setN] = useState(_count);
  useEffect(() => {
    if (!enabled) return undefined;
    _subs.add(setN); setN(_count);
    if (_subs.size === 1) {
      _timer = shellPoll('to_invoice', apply);   // now + every 60 s
      _unsub = onDataMutation(ep => { if (touchesWorklist(ep)) load(); });
    }
    return () => { _subs.delete(setN); if (!_subs.size) { _timer(); if (_unsub) _unsub(); } };
  }, [enabled]);
  return n;
}
